import { MB_CONFIG } from '../config'

export default {

    /*
    *    GET /api/v1/records
    */
    getAll: () => {
        return axios.get(MB_CONFIG.API_URL + '/records/all')
    },

    /*
    *    GET /api/v1/records/refresh/{lastUpdate}
    */
    refresh: (lastUpdate) => {
        if (lastUpdate) {
            return axios.get(MB_CONFIG.API_URL + '/records/refresh/' + lastUpdate)
        }
        return axios.get(MB_CONFIG.API_URL + '/records/all')
    },

}
